/* eslint-disable */
<template>
  <div id="app">
    <header>
      <b-container fluid class="nav-fluid-container">
        <b-navbar toggleable="" type="dark" class="topnav" v-bind:class="{ landingnav: landingnav, presentationnav: presentationnav }">
          <!-- <b-navbar-brand><img class="logo" v-bind:src="'./assets/logoblk-' + i18n.locale + '.svg'" alt="3M Science. Applied To Life. Logo" /></b-navbar-brand> -->
          <b-navbar-brand>
            <img class="logo" :src="require(`@/assets/logoblk-${i18n.locale}.svg`)" alt="3M Science. Applied To Life. Logo" />
          </b-navbar-brand>
          <!-- 
              <b-navbar-brand><img class="logo" v-if="landingnav && !presentationnav"
              v-bind:src='"./assets/logowht-"+ i18n.locale +".svg" ' alt="3M Science. Applied To Life. Logo"><img
              class="logo" v-if="!landingnav && !presentationnav" v-bind:src='"./assets/logoblk-"+ i18n.locale +".svg" '
              alt="3M Science. Applied To Life. Logo"></b-navbar-brand> -->

          <div v-b-toggle:nav_collapse>
            <span class="settings" v-bind:class="{ landingnav: landingnav, presentationnav: presentationnav }">Settings</span>
            <!-- <img class="settingsicon" v-if="landingnav" v-bind:src='"./assets/settings.svg"' alt="Settings">
        <img class="settingsicon" v-if="!landingnav || !presentationnav" v-bind:src='"./assets/settingsblk.svg"' alt="Settings"> -->

            <svg v-bind:class="{ presentationnav: presentationnav, landingnav: landingnav }" xmlns="http://www.w3.org/2000/svg" width="37.858" height="37.858" viewBox="0 0 37.858 37.858">
              <g id="Group_770" data-name="Group 770" transform="translate(1 1)">
                <path
                  id="Path_686"
                  data-name="Path 686"
                  d="M175.3,212.768h5.061V208.09H175.3a18.4,18.4,0,0,0-1.564-4.556l3.58-3.578-4.411-4.411-3.581,3.58a18.286,18.286,0,0,0-4.552-1.562V192.5H160.09v5.064a18.3,18.3,0,0,0-4.554,1.562l-3.581-3.58-4.411,4.411,3.581,3.58a18.431,18.431,0,0,0-1.565,4.554H144.5v4.677h5.061a18.429,18.429,0,0,0,1.565,4.554l-3.581,3.581,4.411,4.409,3.58-3.583a18.34,18.34,0,0,0,4.556,1.568v5.061h4.677V223.3a18.4,18.4,0,0,0,4.552-1.565l3.583,3.58,4.409-4.409-3.58-3.581A18.429,18.429,0,0,0,175.3,212.768Z"
                  transform="translate(-144.5 -192.5)"
                  fill="none"
                  stroke="#000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <ellipse id="Ellipse_184" data-name="Ellipse 184" cx="7.182" cy="7.182" rx="7.182" ry="7.182" transform="translate(10.338 10.786)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
              </g>
            </svg>
          </div>
          <b-collapse is-nav id="nav_collapse">
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-item :disabled="landingnav ? '' : false" :to="'/' + $router.currentRoute.params.lang + '/'"> {{ $t("master.returnhome") }}</b-nav-item>
              <!-- <b-nav-item disabled>{{ $t("master.checkforupdates") }}</b-nav-item> -->

              <!-- <b-nav-item-dropdown right v-if="this.$root.isLoggedIn">
          <template slot="button-content">{{ $t("master.myaccount") }}</template>
          <b-dropdown-item :to="'/' + $router.currentRoute.params.lang + '/profile'">{{ $t("master.profile") }}</b-dropdown-item>     
          <b-dropdown-item :to="'/' + $router.currentRoute.params.lang + '/profile/settings'">{{ $t("certificate.mysettings") }}</b-dropdown-item>        
          <b-dropdown-item :to="'/' + $router.currentRoute.params.lang + '/logout'">{{ $t("master.logout") }}</b-dropdown-item>
          
        </b-nav-item-dropdown> -->

              <!-- <b-nav-item-dropdown v-model="$root.$i18n.locale" right>
                <template slot="button-content">{{ $t("master.language") }}</template>
                <b-dropdown-item v-for="(lang, i) in langs" :key="`Lang${i}`" @click="changeLocale(lang)" :value="lang">
                  {{ lang }}</b-dropdown-item>
              </b-nav-item-dropdown> -->
              <b-nav-item :disabled="!$root.isLoggedIn ? '' : false" @click="logout">{{ $t("master.logout") }} </b-nav-item>
              <b-nav-item v-b-toggle:nav_collapse>{{ $t("master.close") }}</b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </b-container>
    </header>
    <transition name="fade" mode="out-in">
      <router-view v-bind:userProfile="user"></router-view>
    </transition>
    <b-modal id="terms" :ok-title="$t('master.okay')" ok-only size="lg" :title="$t('landing.termtitle')">
      <div v-html="$t('master.terms')"></div>
    </b-modal>

    <b-navbar fixed="bottom" v-bind:class="{ presentationnav: presentationnav }">
      <footer>
        <div class="row align-items-end black" v-bind:class="{ landingfooter: landingnav }">
          <div class="col-lg-4 order-lg-1 order-2 d-flex justify-content-start">
            <div class="MMMfooter media-body">
              <a class="copyrightLinks" :href="$router.currentRoute.params.lang == 'en' ? 'http://www.3mcanada.ca/3M/en_CA/company-ca/legal-information/' : 'https://www.3mcanada.ca/3M/fr_CA/company-ca/legal-information/'" target="_blank">{{ $t("master.legal") }}</a>
              &nbsp;|&nbsp;
              <a class="copyrightLinks" :href="$router.currentRoute.params.lang == 'en' ? 'http://www.3mcanada.ca/3M/en_CA/company-ca/privacy-policy/' : 'https://www.3mcanada.ca/3M/fr_CA/company-ca/privacy-policy/'" target="_blank">{{ $t("master.privacy") }}</a>
              &nbsp;|&nbsp; <a class="copyrightLinks">v1.1.0</a>
              <p class="copy">&copy; {{ $t("master.copyright") }}</p>
              <p><a class="termslink" v-b-modal.terms v-html="$t('landing.clickterms')"></a></p>
            </div>
          </div>
          <div class="col-sm-9 col-lg-8 order-lg-2 order-1">
            <p class="copyCondense d-none d-sm-block" v-html="$t('master.copyrightlegal')"></p>
            <p class="copyCondense">{{ $t("master.trademark") }}</p>
          </div>
        </div>
      </footer>
    </b-navbar>
  </div>
</template>
<script>
import { getHeader, uploadHeader, getHeaderAuth } from "./headers.js"; // eslint-disable-line no-unused-vars
export default {
  name: "app",
  data() {
    return {
      loggedin: false,
      langs: ["en", "fr"],
      landingnav: false,
      presentationnav: false,
      user: [],
      alreadyChecked: false,
    };
  },
  methods: {
    changeLocale(locale) {
      let vm = this;
      let curr = vm.$route.name;
      vm.$router.push({
        name: curr,
        params: {
          lang: locale,
        },
      });
    },
    checkSession() {
      let vm = this;
      //Check to see if session exists
      if (vm.$session.exists()) {
        let exp = new Date(vm.$session.get("expiry")).getTime();
        let now = new Date().getTime();
        //Check if expiry token is dated
        if (now > exp) {
          vm.$session.clear();
          vm.$root.isLoggedIn = false;
          return;
        } else {
          if (vm.$session.get("jwt") != null) {
            //Check to see what happens when timer runs out
            vm.$root.isLoggedIn = true;
          }
          return;
        }
        // return;
      }
    },
    logout() {
      let vm = this;
      this.$session.clear();
      vm.$root.isLoggedIn = false;
      vm.$router.push({
        path: "/",
      });

      this.deleteDatabase();
    },

    deleteDatabase() {
      const dbName = "my-db";

      const request = indexedDB.deleteDatabase(dbName);

      console.log(`delete db`);
    },
  },
  watch: {
    $route: function () {
      let vm = this;
      if (this.$route.name == "Landing Page") {
        this.landingnav = false;
      } else {
        this.landingnav = false;
      }
      if (this.$route.name == "Presentation") {
        this.presentationnav = true;
      } else {
        this.presentationnav = false;
      }
      vm.$router.currentRoute.params.lang;
      if (!vm.$session.exists()) {
        //Once logged out, do this:
        vm.loggedin = false;
        vm.user = [];
      }
      vm.alreadyChecked = false;
    },
  },
  mounted() {},
  beforeCreated() {
    console.log("loggedin: " + vm.$root.isLoggedIn);
    if (this.$session.exists() && this.$session.has("jwt")) {
      vm.$root.isLoggedIn = true;
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/css/global.scss";
</style>
